import styled from 'styled-components';
import { AvInput } from 'availity-mobx-reactstrap-validation';

export default styled(AvInput)`
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding-right: 2.25rem;
  text-overflow: ellipsis;

  &:disabled,
  &[readonly] {
    background: white;
  }
`;
